<template>
	<div class="mia-SubjectPreview">
		<list-store-registration :store="listStore" :data-url="dataUrl" />
		<conversion-store-registration :store="conversionStore" :conversion-url="conversionUrl" />
		<vue-list
			:items="listStore"
			:conversions="conversionStore"
			template="subject"
			class="mia-topOverflowVisible"
			:item-props="{
				selectedSubjectStoreName
			}"
		/>
		<div class="mia-subject row col-xs-55">
			<div class="mia-subjectInfo col-xs-60 col-md-30">
				<h3 v-tr="SubjectTR" />
				<p v-tr="'landingPage_subjectPreview_description_' + currentSubjectModel.Subject" />
				<div class="mia-units">
					<strong v-for="(unit, index) in currentSubjectModel.Units" :key="index"
						class="mia-unit col-xs-30 col-sm-20"
					>
						<tippy @show="() => unit.trim()" trigger="click" placement="bottom">
							<span class="mia-category-name">
								{{ unit }}
							</span>
							<template #content>
								{{ $tr("landingpage_subjectpreview_subunittooltip") }}
							</template>
						</tippy>
					</strong>
				</div>
			</div>
			<div class="mia-subjectVideo col-xs-60 col-md-30">
				<i v-tr="{ key: 'landingpage_subjectpreview_videoheader', 'trusted subjectCategory': $tr(SubjectTR) }" />
				<video controls :src="currentSubjectModel.Video.VideoSrc" :poster="currentSubjectModel.Video.ThumbnailSrc" />
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import VueListUrlHelper from "@/Control/Vue/Lists/VueList/VueListUrlHelper";
import SubjectHelper from "@/utils/SubjectHelper";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { useSelectedItemStore } from "@/Control/Vue/Stores/SelectedItemStore";

import VueList from "../../../../Control/Vue/Lists/VueList/VueList.vue";
import ConversionStoreRegistration from "../../../../Control/Vue/Stores/VueList/ConversionStoreRegistration";
import ListStoreRegistration from "../../../../Control/Vue/Stores/VueList/ListStoreRegistration";
import { MiaPlaza } from "../../../../Reinforced.Typings";
import { Tippy } from "vue-tippy";

@Component({
	components: { VueList, ListStoreRegistration, ConversionStoreRegistration, Tippy },
})
export class SubjectPreview extends Vue {
	@Prop({ required: true }) selectedSubjectStoreName!: string;

	listStore = "subjects-list";
	conversionStore = "subjects-conversion";

	get dataUrl(): string {
		return VueListUrlHelper.GetDataUrl(MiaPlaza.Controllers.Public.SubjectsController.GetSubjectsUrl());
	}

	get conversionUrl(): string {
		return VueListUrlHelper.GetConversionUrl((parameter: MiaPlaza.IPlaceholder) =>
			MiaPlaza.Controllers.Public.SubjectsController.GetSubjectUrl(parameter));
	}

	get currentSubjectModel() {
		return useSelectedItemStore(this.selectedSubjectStoreName).selected!;
	}

	get SubjectTR() {
		return SubjectHelper.GetTrKey(this.currentSubjectModel.Subject);
	}
}

export default toNative(SubjectPreview);
</script>
<style lang="scss">
.mia-SubjectPreview {
	display: flex;
	flex-direction: column;
	box-shadow: theme.$mia-shadow-box;
	margin-top: theme.$mia-grid-gutter-width * 2;

	swiper-container::part(wrapper) {
		margin-top: theme.$mia-margin-size-large;
	}

	.mia-subject {
		margin: 0 auto;
		padding-top: theme.$mia-padding-panel-large;
		padding-bottom: theme.$mia-padding-panel-large;

		.mia-units {
			display: flex;
			flex-wrap: wrap;

			.mia-unit {
				padding: theme.$mia-padding-panel-small;
				padding-left: 0;
				.mia-category-name {
					cursor: pointer;
				}
			}
		}
	}

	.mia-subjectVideo {
		margin-top: calc(theme.$mia-grid-gutter-width * 2);
	}

	.mia-topOverflowVisible {
		margin-top: calc(-#{theme.$mia-padding-panel-large});
	}
}

@media(max-width: theme.$screen-sm-max) {
	.mia-SubjectPreview {
		.mia-subject {
			padding-top: theme.$mia-padding-panel;
		}

		.mia-subjectVideo {
			margin-top: theme.$mia-grid-gutter-width;
		}
	}
}
</style>
